/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} QuarterlyInputs */

const en_quarterly = /** @type {(inputs: QuarterlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quarterly`)
};

const de_quarterly = /** @type {(inputs: QuarterlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vierteljährlich`)
};

/**
* | output |
* | --- |
* | "Quarterly" |
*
* @param {QuarterlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quarterly = /** @type {((inputs?: QuarterlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<QuarterlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quarterly(inputs)
	return de_quarterly(inputs)
});